import React, { useEffect, useState } from "react";
import { MediaAttachment } from "src/shared/types/src";
import MediaTypeDisplay from "./MediaTypeDisplayComponent";

type IProps = { 
    media: MediaAttachment[] 
}

const InlineMediaCollageContainer: React.FC<IProps> = ({ media }) => {

    const [slicedMedia, setSlicedMedia] = useState<MediaAttachment[]>(media);

    useEffect(() => {
        setSlicedMedia(media.slice(0, 4));
    }, [media]);

    return (
        <div className="d-flex mx-n-4">
            {
                slicedMedia.map((item, index) =>
                    <div className="media-collage-inline-4 pd-x-4" key={index}>
                        <div className="media-collage-item">
                            <MediaTypeDisplay media={item} collageDisplay={true} />
                            {
                            (media.length > 4 && index === 3) ? 
                            <div className="media-collage-count">
                                <span>+ {media.length - 4}</span>
                            </div> : null
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default InlineMediaCollageContainer;